
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.018 3.01161L2.15392 11.3433C2.05363 11.5215 2.00057 11.7235 2 11.9293C1.99944 12.1351 2.0514 12.3374 2.15071 12.5162C2.25003 12.695 2.39323 12.8439 2.56607 12.9483C2.73892 13.0526 2.93538 13.1087 3.13592 13.111H12.8641C13.0646 13.1087 13.2611 13.0526 13.4339 12.9483C13.6068 12.8439 13.75 12.695 13.8493 12.5162C13.9486 12.3374 14.0006 12.1351 14 11.9293C13.9994 11.7235 13.9464 11.5215 13.8461 11.3433L8.982 3.01161C8.87963 2.83844 8.73548 2.69526 8.56347 2.5959C8.39146 2.49653 8.1974 2.44433 8 2.44433C7.8026 2.44433 7.60854 2.49653 7.43653 2.5959C7.26452 2.69526 7.12037 2.83844 7.018 3.01161Z","stroke":"#10001F","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 6.44433V8.44433","stroke":"#10001F","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.69976 10.6038C8.69976 10.9904 8.38636 11.3038 7.99976 11.3038C7.61316 11.3038 7.29976 10.9904 7.29976 10.6038C7.29976 10.2172 7.61316 9.9038 7.99976 9.9038C8.38636 9.9038 8.69976 10.2172 8.69976 10.6038Z","fill":"#10001F"}})])
          )
        }
      }
    